module.exports = "<ng-content *ngIf=\"isActive\"></ng-content>\n"